import { QRCodeSVG } from 'qrcode.react';
import { API } from '@unboared/react';

import scan2play from '~/assets/img/scan2play.png';
import { Game } from '~/types/game';
import { Logo } from '~/components/design/logo';

import styles from './InfoPanel.module.css';
import { Ranking } from './Ranking';

export function InfoPanel({ game, clientID }: { clientID: string; game: Game }) {
    return (
        <div className={styles.container}>
            <div className={styles.firstPart}>
                <div className={styles.qrContainer}>
                    <QRCodeSVG className={styles.qrcode} value={API.getSessionLink()} />
                </div>
                <img className={styles.scan2play} src={scan2play} alt="SCAN TO PLAY" />
            </div>
            <div className={styles.logoContainer}>
                <Logo className={styles.logo} />
            </div>
            <div className={styles.rankingContainer}>
                <Ranking clientID={clientID} game={game} />
            </div>
        </div>
    );
}
